import Vue from 'vue'
import Utils from './Utils'

const Specials = {

	play: function(slot, store) {
		var function_name = slot.card.slug.replace(new RegExp('-', 'g'), '_');
		if (typeof this[function_name] === 'function') {
			this[function_name](slot, store);
		}
	},

	shuffle: function(slot, store) {
		store.dispatch('shuffle')
	},

	upgrade_all: function(slot, store) {
		var slots = _.filter(store.getters.board, function(slot) { return slot.card && slot.card.type == 'default' && slot.card.value < 9 })
		for (var i in slots) {
			store.commit('EDIT_CARD', { card: slots[i].card, value: slots[i].card.value + 1 })
		}
	},

	downgrade_all: function(slot, store) {
		var slots = _.filter(store.getters.board, function(slot) { return slot.card && slot.card.type == 'default' && slot.card.value > 1 })
		for (var i in slots) {
			store.commit('EDIT_CARD', { card: slots[i].card, value: slots[i].card.value - 1 })
		}
	},

	explosion: function(slot, store) {
		var slots = Utils.get_adjacents({ slot: slot, board: store.getters.board })
		for (var i in slots) {
			if (slots[i] && slots[i].card) store.commit('EDIT_SLOT', { slot: slots[i], card: false })
		}
	},

	destruction: function(slot, store) {
		var slots = _.sampleSize( _.filter(store.getters.board, function(slot) { return slot.card }) , 3)
		for (var i in slots) {
			if (slots[i] && slots[i].card) store.commit('EDIT_SLOT', { slot: slots[i], card: false })
		}
	},

	transformation: function(slot, store) {
		var slots = _.sampleSize( _.filter(store.getters.board, function(slot) { return slot.card && slot.card.type == 'default' && slot.card.value < 9 }) , 3)
		for (var i in slots) {
			store.commit('EDIT_CARD', { card: slots[i].card, value: 9 })
		}
	},

	double: function(slot, store) {
		var slots = _.filter(store.getters.board, function(slot) { return slot.card && slot.card.type == 'default' && slot.card.value < 5 })
		for (var i in slots) {
			store.commit('EDIT_CARD', { card: slots[i].card, value: slots[i].card.value * 2 })
		}
	},

	concentration: function(slot, store) {
		store.commit('EDIT_STATE', { life: 4 })
	}

}

export default Specials 


// WEBPACK FOOTER //
// ./src/core/Specials.js